<template>
    <div>
        <ckeditor :editor="editor" v-model="editorData" :config="editorConfig" @input="onEditorInput"/>
    </div>
</template>

<script>
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
    import CKEditor from '@ckeditor/ckeditor5-vue'

    class Base64UploadAdapter {
        constructor(loader) {
            this.loader = loader;
        }
        upload() {
            return this.loader.file.then(file => new Promise((resolve, reject) => {
                const maxSize = 10 * 1024 * 1024;
                if (file.size > maxSize) {
                    alert('이미지는 10M 이하만 가능합니다.');
                    reject('이미지는 10M 이하만 가능합니다.');
                    return;
                }
                const reader = new FileReader();
                reader.addEventListener('load', () => resolve({ default: reader.result }));
                reader.addEventListener('error', err => reject(err));
                reader.addEventListener('abort', () => reject());
                reader.readAsDataURL(file);
            }));
        }
        abort() {}
    }

    function Base64UploadAdapterPlugin(editor) {
        editor.plugins.get('FileRepository').createUploadAdapter = loader => new Base64UploadAdapter(loader);
    }

    export default {
        name: 'CKEditor',
        components: {
            ckeditor: CKEditor.component
        },
        props: {
            content: {
                type: String,
                default: ''
            }
        },
        data: () => ({
            editor: ClassicEditor,
            editorData:'',
            //editorData: '<pre>입력해주세요</pre>',
            editorConfig: {
                // The configuration of the editor.
                height: '500px',
                language: 'ko',
                removePlugins : ['CKFinderUploadAdapter', 'CKFinder', 'EasyImage', 'MediaEmbed'],
                extraPlugins: [Base64UploadAdapterPlugin],
                placeholder:"내용을 입력해주세요"
            }
        }),
        watch: {
            content: {
                immediate: true,
                handler(newVal){
                    this.editorData = newVal || '';
                }
            }
        },
        methods : {
            onEditorInput(){
                this.$emit('getContents',this.editorData);
            }
        }

    }
</script>